// extracted by mini-css-extract-plugin
module.exports =  {"form":"WF4NF9"};